import { defineComponent, pushScopeId, popScopeId, openBlock, createBlock, Fragment, renderList, createVNode, createCommentVNode, withScopeId, createStaticVNode } from 'vue';

var script$2 = /*#__PURE__*/defineComponent({
  name: "ParagraphShimmer",
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    lines: {
      type: Number,
      default: 3
    },
    randomSize: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getWidth() {
      if (this.randomSize) return Math.floor(Math.random() * (100 - 80 + 1) + 80);
      return 100;
    }

  }
});

const _withId$2 = /*#__PURE__*/withScopeId("data-v-53cb3bd7");

pushScopeId("data-v-53cb3bd7");

const _hoisted_1$2 = {
  key: 0,
  class: "shimmer"
};

popScopeId();

const render$2 = /*#__PURE__*/_withId$2((_ctx, _cache, $props, $setup, $data, $options) => {
  return _ctx.isLoading ? (openBlock(), createBlock("div", _hoisted_1$2, [(openBlock(true), createBlock(Fragment, null, renderList(_ctx.lines, i => {
    return openBlock(), createBlock("div", {
      key: i
    }, [createVNode("div", {
      class: "text-item",
      style: 'width: ' + _ctx.getWidth() + '%'
    }, null, 4)]);
  }), 128))])) : createCommentVNode("", true);
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = "\n.text-item[data-v-53cb3bd7] {\n  height: 12px;\n  border-radius: 5px;\n  margin-bottom: 8px;\n  position: relative;\n  overflow: hidden;\n  background-color: rgb(211, 211, 211);\n}\n.text-item[data-v-53cb3bd7]::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: -150px;\n  top: 0;\n  height: 100%;\n  width: 150px;\n  background-image: linear-gradient(\n    to left,\n    rgba(251, 251, 251, 0.05),\n    rgba(251, 251, 251, 0.3),\n    rgba(251, 251, 251, 0.6),\n    rgba(251, 251, 251, 0.3),\n    rgba(251, 251, 251, 0.05)\n  );\n  background-image: -moz-linear-gradient(\n    to left,\n    rgba(251, 251, 251, 0.05),\n    rgba(251, 251, 251, 0.3),\n    rgba(251, 251, 251, 0.6),\n    rgba(251, 251, 251, 0.3),\n    rgba(251, 251, 251, 0.05)\n  );\n  background-image: -webkit-linear-gradient(\n    to left,\n    rgba(251, 251, 251, 0.05),\n    rgba(251, 251, 251, 0.3),\n    rgba(251, 251, 251, 0.6),\n    rgba(251, 251, 251, 0.3),\n    rgba(251, 251, 251, 0.05)\n  );\n  animation: load-53cb3bd7 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n}\n@keyframes load-53cb3bd7 {\nfrom {\n    left: -150px;\n}\nto {\n    left: 100%;\n}\n}\n";
styleInject(css_248z$2);

script$2.render = render$2;
script$2.__scopeId = "data-v-53cb3bd7";

var script$1 = /*#__PURE__*/defineComponent({
  name: "CardShimmer",
  props: {
    isLoading: {
      type: Boolean,
      default: true
    }
  }
});

const _withId$1 = /*#__PURE__*/withScopeId("data-v-7d210bae");

pushScopeId("data-v-7d210bae");

const _hoisted_1$1 = {
  key: 0,
  class: "shimmer"
};

const _hoisted_2 = /*#__PURE__*/createStaticVNode("<div class=\"shimmer-card\" data-v-7d210bae><div class=\"card-image\" data-v-7d210bae></div><div class=\"para\" data-v-7d210bae><div class=\"text-item\" style=\"width:92%;\" data-v-7d210bae></div><div class=\"text-item\" style=\"width:70%;\" data-v-7d210bae></div><div class=\"text-item\" data-v-7d210bae></div><div class=\"text-item\" style=\"width:20%;\" data-v-7d210bae></div></div></div>", 1);

popScopeId();

const render$1 = /*#__PURE__*/_withId$1((_ctx, _cache, $props, $setup, $data, $options) => {
  return _ctx.isLoading ? (openBlock(), createBlock("div", _hoisted_1$1, [_hoisted_2])) : createCommentVNode("", true);
});

var css_248z$1 = "\n.shimmer-card[data-v-7d210bae] {\r\n  background: #ffffff;\r\n  width: 280px;\r\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),\r\n    0 4px 6px -2px rgba(0, 0, 0, 0.05);\r\n  border-radius: 12px;\r\n  overflow: hidden;\n}\n.para[data-v-7d210bae] {\r\n  padding: 16px;\n}\n.card-image[data-v-7d210bae] {\r\n  height: 220px;\r\n  position: relative;\r\n  overflow: hidden;\r\n  background-color: rgb(211, 211, 211);\n}\n.text-item[data-v-7d210bae] {\r\n  height: 12px;\r\n  border-radius: 5px;\r\n  margin-bottom: 8px;\r\n  position: relative;\r\n  overflow: hidden;\r\n  background-color: rgb(211, 211, 211);\n}\n.card-image[data-v-7d210bae]:before,\r\n.text-item[data-v-7d210bae]::before {\r\n  content: \"\";\r\n  display: block;\r\n  position: absolute;\r\n  left: -150px;\r\n  top: 0;\r\n  height: 100%;\r\n  width: 150px;\r\n  background-image: linear-gradient(\r\n    to left,\r\n    rgba(251, 251, 251, 0.05),\r\n    rgba(251, 251, 251, 0.3),\r\n    rgba(251, 251, 251, 0.6),\r\n    rgba(251, 251, 251, 0.3),\r\n    rgba(251, 251, 251, 0.05)\r\n  );\r\n  background-image: -moz-linear-gradient(\r\n    to left,\r\n    rgba(251, 251, 251, 0.05),\r\n    rgba(251, 251, 251, 0.3),\r\n    rgba(251, 251, 251, 0.6),\r\n    rgba(251, 251, 251, 0.3),\r\n    rgba(251, 251, 251, 0.05)\r\n  );\r\n  background-image: -webkit-linear-gradient(\r\n    to left,\r\n    rgba(251, 251, 251, 0.05),\r\n    rgba(251, 251, 251, 0.3),\r\n    rgba(251, 251, 251, 0.6),\r\n    rgba(251, 251, 251, 0.3),\r\n    rgba(251, 251, 251, 0.05)\r\n  );\r\n  animation: load-7d210bae 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n}\n@keyframes load-7d210bae {\nfrom {\r\n    left: -150px;\n}\nto {\r\n    left: 100%;\n}\n}\r\n";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-7d210bae";

var script = /*#__PURE__*/defineComponent({
  name: "FreeStyleShimmer",
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    width: {
      required: true
    },
    height: {
      required: true
    },
    borderRadius: {
      default: "5px"
    },
    color: {
      default: "rgb(211,211,211)"
    }
  }
});

const _withId = /*#__PURE__*/withScopeId("data-v-62e0c85a");

pushScopeId("data-v-62e0c85a");

const _hoisted_1 = {
  key: 0,
  class: "shimmer"
};

popScopeId();

const render = /*#__PURE__*/_withId((_ctx, _cache, $props, $setup, $data, $options) => {
  return _ctx.isLoading ? (openBlock(), createBlock("div", _hoisted_1, [createVNode("div", {
    class: "free-style",
    style: 'width: ' + _ctx.width + '; height: ' + _ctx.height + '; border-radius: ' + _ctx.borderRadius + '; background-color: ' + _ctx.color + ';'
  }, null, 4)])) : createCommentVNode("", true);
});

var css_248z = "\n.free-style[data-v-62e0c85a] {\r\n  position: relative;\r\n  overflow: hidden;\n}\n.free-style[data-v-62e0c85a]::before {\r\n  content: \"\";\r\n  display: block;\r\n  position: absolute;\r\n  left: -150px;\r\n  top: 0;\r\n  height: 100%;\r\n  width: 150px;\r\n  background-image: linear-gradient(\r\n    to left,\r\n    rgba(251, 251, 251, 0.05),\r\n    rgba(251, 251, 251, 0.3),\r\n    rgba(251, 251, 251, 0.6),\r\n    rgba(251, 251, 251, 0.3),\r\n    rgba(251, 251, 251, 0.05)\r\n  );\r\n  background-image: -moz-linear-gradient(\r\n    to left,\r\n    rgba(251, 251, 251, 0.05),\r\n    rgba(251, 251, 251, 0.3),\r\n    rgba(251, 251, 251, 0.6),\r\n    rgba(251, 251, 251, 0.3),\r\n    rgba(251, 251, 251, 0.05)\r\n  );\r\n  background-image: -webkit-linear-gradient(\r\n    to left,\r\n    rgba(251, 251, 251, 0.05),\r\n    rgba(251, 251, 251, 0.3),\r\n    rgba(251, 251, 251, 0.6),\r\n    rgba(251, 251, 251, 0.3),\r\n    rgba(251, 251, 251, 0.05)\r\n  );\r\n  animation: load-62e0c85a 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n}\n@keyframes load-62e0c85a {\nfrom {\r\n    left: -150px;\n}\nto {\r\n    left: 100%;\n}\n}\r\n";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-62e0c85a";

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ParagraphShimmer: script$2,
  CardShimmer: script$1,
  FreeStyleShimmer: script
});

const install = function installVue3Shimmer(app) {
  Object.entries(components).forEach(([componentName, component]) => {
    app.component(componentName, component);
  });
};

export default install;
export { script$1 as CardShimmer, script as FreeStyleShimmer, script$2 as ParagraphShimmer };
